
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import Store from './Store/Store';
import ToastProvider from './Components/Toast/ToastProvider';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import * as ServiceWorkerRegistration from './Context/serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={Store}>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);

// Register service worker 👇
ServiceWorkerRegistration.register();
